/// <reference path='../../../../node_modules/bingmaps/types/MicrosoftMaps/Microsoft.Maps.All.d.ts' />
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from 'app-modules/core/core.module';

import { RouteEditorRoutingModule } from './route-editor-routing.module';
import { RouteEditorComponent } from './components/route-editor/route-editor.component';
import { RouteDeviationComponent } from './components/route-deviation/route-deviation.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@NgModule({
  declarations: [
  ],
  imports: [
     RouteEditorRoutingModule
  ],
  exports: [
  ]
})
export class RouteEditorModule { }
